export default "__VITE_PUBLIC_ASSET__10f84125__"